import React from 'react';
import { FadeIn } from './FadeIn';
import { Headphones, Calendar, BookOpen, Zap } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <Headphones size={32} data-id="element-188" />,
    title: 'Audiobook SOS: El Reset Metabólico 40+',
    desc: '7 tracks con el paso a paso exacto para navegar tus hormonas.'
  }, {
    icon: <Calendar size={32} data-id="element-189" />,
    title: 'El Protocolo 14 Días',
    desc: 'El mapa de ruta para desinflamarte desde la primera mañana.'
  }, {
    icon: <BookOpen size={32} data-id="element-190" />,
    title: 'Guía de Nutrición Anti-Cortisol',
    desc: 'Qué comer y qué evitar para mantener tu energía estable.'
  }, {
    icon: <Zap size={32} data-id="element-191" />,
    title: 'Audio Bonus SOS Antojos',
    desc: 'La herramienta de 5 minutos para rescatarte de los ataques de hambre nocturnos.'
  }];
  return <section className="py-20 px-6 bg-white" data-id="element-192">
      <div className="max-w-5xl mx-auto" data-id="element-193">
        <FadeIn data-id="element-194">
          <h2 className="font-serif text-3xl md:text-4xl text-charcoal mb-12 text-center" data-id="element-195">
            Lo que recibes hoy
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-196">
            {items.map((item, idx) => <div key={idx} className="bg-cream p-8 rounded-2xl border border-sage/20 hover:border-sage/50 transition-colors flex flex-col items-start gap-4" data-id="element-197">
                <div className="bg-white p-4 rounded-xl text-terracotta shadow-sm" data-id="element-198">
                  {item.icon}
                </div>
                <div data-id="element-199">
                  <h3 className="font-serif text-xl text-charcoal font-bold mb-2" data-id="element-200">
                    {item.title}
                  </h3>
                  <p className="font-sans text-charcoal/70 leading-relaxed" data-id="element-201">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}